<div class="lp-statistics-bar-chart">
  <div class="lp-statistics-bar-chart__header">
    <lp-statistics-widget-header [title]="'components.lpStatisticsBarChart.labels.title' | translate">
      <app-legend *ngIf="legendItems" class="legend" [items]="legendItems"></app-legend>
    </lp-statistics-widget-header>
  </div>

  <tui-axes
    *ngIf="!noData; else noDataTmp"
    class="lp-statistics-bar-chart__content"
    [axisXLabels]="axisXLabels"
    [axisY]="'none'"
    [axisYLabels]="axisYLabels"
    [horizontalLines]="axisYLabels.length - 1"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
  >
    <tui-bar-chart
      [max]="maxValue"
      [value]="values"
      [size]="null"
      [tuiHintAppearance]="darkMode() ? 'error' : ''"
      [tuiHintContent]="hint"
    ></tui-bar-chart>
  </tui-axes>

  <ng-template #noDataTmp>
    <div class="no-data" [class.tui-skeleton]="loading" [class.tui-skeleton_text]="loading">
      {{ 'common.labels.noData' | translate }}
    </div>
  </ng-template>

  <ng-template #hint let-setIndex>
    <div *ngFor="let item of values; let index = index" class="hint">
      {{ getSetName(index) | translate }} — {{ item[setIndex] }}
    </div>
  </ng-template>
</div>
